import type { OrgMember } from '../hooks/useOrgMembers';

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Exibe nome legível do responsável (issues.assigned_to pode ser UUID). */
export function resolveIssueAssigneeName(
  assignedTo: string | null | undefined,
  members: Pick<OrgMember, 'id' | 'name' | 'email'>[],
): string {
  if (!assignedTo?.trim()) return '—';
  const value = assignedTo.trim();
  if (value === 'Eu') return 'Eu';
  if (!UUID_RE.test(value)) return value;
  const member = members.find((m) => m.id === value);
  return member?.name || member?.email || value;
}
